import type { ComputeFilters, ComputeGranularity } from './computeTypes';

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;
const GRANULARITIES = new Set<ComputeGranularity>(['day', 'week', 'month']);

function toIsoDate(date: Date): string {
    return date.toISOString().slice(0, 10);
}

export function defaultComputeFilters(now = new Date()): ComputeFilters {
    const end = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
    const start = new Date(end);
    start.setUTCDate(start.getUTCDate() - 29);
    return {
        startDate: toIsoDate(start),
        endDate: toIsoDate(end),
        geo: '',
        farm: '',
        customerSegment: '',
        sku: '',
        granularity: 'day',
    };
}

export function readComputeFilters(searchParams: URLSearchParams, now = new Date()): ComputeFilters {
    const defaults = defaultComputeFilters(now);
    const granularity = searchParams.get('granularity') as ComputeGranularity | null;
    return {
        startDate: ISO_DATE.test(searchParams.get('startDate') ?? '') ? searchParams.get('startDate')! : defaults.startDate,
        endDate: ISO_DATE.test(searchParams.get('endDate') ?? '') ? searchParams.get('endDate')! : defaults.endDate,
        geo: searchParams.get('geo')?.trim() ?? '',
        farm: searchParams.get('farm')?.trim() ?? '',
        customerSegment: searchParams.get('customerSegment')?.trim() ?? '',
        sku: searchParams.get('sku')?.trim() ?? '',
        granularity: granularity && GRANULARITIES.has(granularity) ? granularity : defaults.granularity,
    };
}

export function writeComputeFilters(current: URLSearchParams, filters: ComputeFilters): URLSearchParams {
    const next = new URLSearchParams(current);
    next.set('startDate', filters.startDate);
    next.set('endDate', filters.endDate);
    next.set('granularity', filters.granularity);
    filters.geo ? next.set('geo', filters.geo) : next.delete('geo');
    filters.farm ? next.set('farm', filters.farm) : next.delete('farm');
    filters.customerSegment ? next.set('customerSegment', filters.customerSegment) : next.delete('customerSegment');
    filters.sku ? next.set('sku', filters.sku) : next.delete('sku');
    return next;
}
